module.exports = __webpack_public_path__ + "static/media/S2.75c25af2.webp";